import { useEffect, useState } from 'react'
import { Button } from './Button'
import { PlusCircleIcon } from '@heroicons/react/24/solid'
import usePodcastFormStepsStore from 'store/usePodcastFormStepsStore'

export const SpeakerInput = () => {
  const labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const { podcast, updatePodcast } = usePodcastFormStepsStore()

  const initialSpeakers = (podcast?.speakers as string[]) || ['A', 'B']
  const [speakers, setSpeakers] = useState(initialSpeakers)

  useEffect(() => {
    if (speakers.length > 0) {
      updatePodcast({ ...podcast, speakers })
    } else {
      updatePodcast({ ...podcast, speakers: ['A'] })
    }
  }, [speakers])

  const handleChange = (e, index) => {
    const updatedSpeaker = e.target.value || labels[index]
    setSpeakers((currentSpeakers) => {
      const updatedSpeakers = [...currentSpeakers]
      updatedSpeakers[index] = updatedSpeaker
      return updatedSpeakers
    })
  }

  return (
    <div className="flex flex-col items-end justify-end">
      {speakers.map((speaker, index) => {
        return (
          <div className="mt-1 flex w-full items-center gap-2" key={index}>
            <span>{labels[index]}</span>
            <input
              type="text"
              value={speaker}
              onChange={(e) => handleChange(e, index)}
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
            />
            <button
              className="text-sm text-red-500"
              onClick={() => {
                setSpeakers((currentSpeakers) => {
                  const updatedSpeakers = [...currentSpeakers]
                  updatedSpeakers.splice(index, 1)
                  return updatedSpeakers
                })
              }}
            >
              Remove
            </button>
          </div>
        )
      })}
      <Button
        variant="solid"
        color="blue"
        className="mt-2"
        onClick={() => {
          setSpeakers((currentSpeakers) => [
            ...currentSpeakers,
            labels[currentSpeakers.length],
          ])
        }}
      >
        <PlusCircleIcon className="mr-1 h-4 w-4" />
        Add Another Speaker
      </Button>
    </div>
  )
}
